import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined') {
      // @ts-ignore
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      // @ts-ignore
      fbq('init', '431177316638551');
      // @ts-ignore
      fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-118">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=431177316638551&ev=PageView&noscript=1" alt="" data-id="element-119" />
    </noscript>;
}